export const educationList = [
  '부산대학교 법학과',
  '제48회 사법시험 합격',
  '사법연수원 38기',
];

export const careerList = [
  '대전지방법원 개인 및 법인 파산관재인',
  '대전가정법원 전문성년후견인 후보자',
  '대전광역시 행정심판위원회 위원',
  '대전지방경찰청 수사심의위원회 위원',
  '한국가스기술공사 정보공개심의위원회 위원',
  '한국수목원정원관리원 청렴옴부즈만 위원',
  '전 대전광역시 집합건물분쟁조정위원회 위원',
  '전 대전도시공사 분양가 심의위원',
  '전 용인시 행정정보공개심의회 위원',
  '전 경희 법무법인 변호사',
  '전 법무법인 명경 변호사',
  '전 부산지방검찰청 직무대리',
  '전 부산지방법원 수습',
];

export const practiceAreas = [
  {
    icon: 'ri-home-heart-line',
    title: '이혼 및 재산분할',
    desc: '이혼, 재산분할, 양육비 사건, 상간녀사건 등 가사사건 전문 수행',
    keywords: ['이혼', '재산분할', '양육비', '위자료', '상간녀'],
    steps: ['무료·유료 상담으로 사건 개요와 쟁점 파악', '혼인관계 및 재산 내역 자료 수집·검토', '이혼 방식(협의·조정·소송)과 전략 수립', '재산분할·양육권 협상 및 소송 수행', '판결 후 후속 조치와 마무리 상담'],
    points: ['혼인신고일, 별거 시점 등 기본 사실관계 정리', '재산 목록(부동산·예금·보험·퇴직금) 준비', '양육권·양육비에 대한 본인의 의사 정리'],
  },
  {
    icon: 'ri-shield-check-line',
    title: '이혼 관련 형사사건',
    desc: '가정폭력, 폭행, 강요, 협박, 명예훼손, 업무방해, 통신비밀보호법위반, 정통망법위반 등',
    keywords: ['가정폭력', '폭행', '협박', '명예훼손', '업무방해'],
    steps: ['고소장·고발장 작성 전 사건 경위 청취', '증거 자료(녹취·문자·진단서) 확보', '수사기관 조사 대응 및 의견서 제출', '합의·공소취소 등 형사 절차 전략 수립', '공판 및 재판 과정 변론 수행'],
    points: ['피해 시점과 경위를 시간 순서대로 메모', '녹취·문자·영상 등 증거 보존', '진단서 등 피해 사실을 입증할 자료 확보'],
  },
  {
    icon: 'ri-scales-3-line',
    title: '각종 민사 사건',
    desc: '대여금, 공사대금, 부동산 등 다양한 민사 분쟁 해결',
    keywords: ['대여금', '공사대금', '부동산', '손해배상', '채권추심'],
    steps: ['분쟁 내용과 계약 관계 파악을 위한 상담', '계약서·거래 내역 등 증거 자료 수집', '내용증명 발송 및 소송 전 협의 진행', '소장 제출 및 재판 절차 진행', '판결에 따른 집행 및 후속 조치'],
    points: ['계약서·영수증·이체 내역 등 서류 준비', '상대방과의 연락 내역(문자·녹취) 정리', '청구 금액과 근거를 구체적으로 정리'],
  },
  {
    icon: 'ri-lock-unlock-line',
    title: '재산범죄',
    desc: '사기, 횡령, 배임 등 각종 재산범죄 사건 수행',
    keywords: ['사기', '횡령', '배임', '보이스피싱', '대출사기'],
    steps: ['피해·피의 사실관계에 대한 정확한 청취', '금전 거래 내역과 증거 자료 분석', '고소·고발 또는 수사 대응 전략 수립', '수사·공판 단계별 의견 제시와 변론', '피해 회복(배상·합의) 방안 마련'],
    points: ['입금 내역·차용증·계약서 등 증빙 확보', '피의자·피해자 입장에 따른 대응 방향 정리', '회수 가능한 재산 및 배상 여부 점검'],
  },
  {
    icon: 'ri-bank-line',
    title: '개인·기업파산회생',
    desc: '개인 및 기업 파산·회생 관련 사건 전문 상담',
    keywords: ['개인회생', '개인파산', '법인회생', '면책', '채무조정'],
    steps: ['채무 현황과 소득·재산 상태 파악', '파산·회생 가능 여부와 적정 절차 진단', '서류 준비 및 법원 접수 진행', '채권자 집회·인가 절차 대응', '면책 결정까지의 사후 관리 안내'],
    points: ['채권자 목록과 채무 금액 정리', '소득 증빙과 재산 목록 준비', '연체·추심 상황에 대한 현황 파악'],
  },
  {
    icon: 'ri-alarm-warning-line',
    title: '성범죄',
    desc: '성범죄, 강제추행 사건 등 형사사건 전문 변호',
    keywords: ['성범죄', '강제추행', '성폭력', '미성년자', '몰카'],
    steps: ['피해·피의 입장에 따른 사건 경위 청취', '증거 및 진술 신빙성 분석·검토', '수사 단계 대응과 의견서 제출', '공판 과정에서의 적극적 변론', '합의·선처 등 유리한 결과 도출'],
    points: ['사건 발생 시점과 경위를 구체적으로 정리', '녹취·문자·CCTV 등 증거 보존', '조사·재판 대응에 대한 심리적 준비'],
  },
];

export const faqList = [
  {
    question: '이혼 소송을 하면 기간이 얼마나 걸리나요?',
    answer: '사건의 쟁점과 상대방의 태도에 따라 다르지만, 대전가정법원 등에서 진행되는 일반적인 재판이혼은 통상 6개월에서 1년 이상 소요되는 경우가 많습니다. 협의가 원만하게 되면 협의이혼으로 훨씬 짧게 마무리할 수 있으므로, 먼저 상담을 통해 본인에게 맞는 절차를 선택하는 것이 중요합니다.',
  },
  {
    question: '이혼 변호사 비용(수임료)은 얼마나 드나요?',
    answer: '수임료는 사건의 성격, 쟁점의 복잡성, 재산 규모 등에 따라 달라져 일률적으로 말씀드리기 어렵습니다만 통상 착수금과 성공보수 구조로 진행됩니다. 정확한 비용은 상담을 통해 사건 내용을 확인한 뒤 안내받으시는 것이 가장 정확합니다.',
  },
  {
    question: '재산분할은 어떻게 산정되나요?',
    answer: '혼인기간 중 부부가 함께 형성한 재산을 기준으로, 재산 형성에 기여한 정도(가사노동 포함)와 혼인기간 등을 종합적으로 고려해 분할 비율이 정해집니다. 대전이혼전문변호사가 부동산·예금·보험·퇴직금 등 재산 내역을 꼼꼼히 분석하여 유리한 분할을 이끌어낼 수 있도록 도와드립니다.',
  },
  {
    question: '양육권과 양육비는 어떻게 정해지나요?',
    answer: '양육권은 자녀의 복리를 최우선으로 고려해 부모의 양육 환경, 자녀와의 친밀도, 자녀의 의사 등을 종합적으로 판단하여 결정됩니다. 양육비는 부모의 소득과 재산 등을 기준으로 산정표에 따라 정해집니다.',
  },
  {
    question: '협의이혼과 재판이혼은 어떻게 다른가요?',
    answer: '협의이혼은 부부가 이혼에 합의하여 법원의 이혼의사확인을 받는 절차이고, 재판이혼은 합의가 되지 않아 법원의 판결로 이혼하는 절차입니다. 협의가 어려운 경우 재판이혼으로 진행하게 되며, 재산분할·양육권 등 쟁점이 복잡할수록 전문 변호사의 도움이 필요합니다.',
  },
  {
    question: '이혼 사유는 어떻게 인정되나요?',
    answer: '민법상 재판상 이혼사유로는 배우자의 부정행위, 악의의 유기, 부당한 대우, 3년 이상 생사불명 등이 있습니다. 이 외에도 혼인관계가 회복하기 어려울 정도로 파탄된 경우 이혼이 인정될 수 있으며, 이를 입증할 증거가 중요합니다.',
  },
  {
    question: '상간자(상간녀)에게 위자료를 청구할 수 있나요?',
    answer: '배우자의 부정행위 상대방(상간자)에게도 위자료를 청구할 수 있습니다. 다만 위자료 액수는 혼인기간, 부정행위의 정도, 상대방의 태도 등에 따라 달라지므로, 증거 확보와 함께 전문 변호사의 조력을 받는 것이 유리합니다.',
  },
  {
    question: '대전에서 이혼 전문 변호사를 선택할 때 기준은 무엇인가요?',
    answer: '이혼·가사사건 경험이 풍부한지, 상담부터 소송까지 변호사가 직접 대응하는지, 그리고 의뢰인의 이야기를 충분히 들어주고 소통이 잘 되는지가 중요합니다. 대전이혼전문변호사 신가영 변호사는 오랜 송무 경험과 꼼꼼한 여성변호사 특유의 장점으로 첫 상담부터 판결까지 책임지고 도와드립니다.',
  },
];

export const whyChooseList = [
  {
    title: '여성변호사 특유의 꼼꼼함',
    desc: '여성변호사 특유의 꼼꼼함으로, 특히 이혼사건에 수반되는 재산분할과 같은 재산 내역의 주장이나 입증에 자신을 가지고 있는 신가영 변호사입니다.',
  },
  {
    title: '변호사가 직접 상담하고 서면을 작성',
    desc: '사건의 처리는 사무장이나 직원을 통해서가 아닌 변호사가 직접 상담하고, 서면을 작성하여 바로바로 의견을 청취하고, 서면이나 변론에 반영하는 방식으로 일처리를 하여 의뢰인과 변호사간의 신뢰가 상당히 잘 형성되는 변호사입니다.',
  },
  {
    title: '친근하고 공감하는 변호사',
    desc: '의뢰인들의 언니, 누나, 친구, 딸 같은, 누구나 가까이 다가갈 수 있는 친절하고 친근한 변호사입니다. 의뢰인의 편에서 진심으로 공감해주고 가능한 방법이나 결과에 대하여 항상 소통하므로 의뢰인들은 재판의 결과를 자연스럽게 받아들이고 납득하는 경우가 많습니다. 판결이 나면 오랜 기간 수고하셨다며 눈물로 인사를 해주시는 의뢰인도 적지 않았습니다.',
  },
  {
    title: '객관적이고 전문적인 법률서비스',
    desc: '그렇다고 해서 친절하기만 한 변호사는 아닙니다. 16년 가량의 오랜 송무 경험을 통해 객관적이고도 전문적인 법률서비스를 제공하며, 의뢰인에게 불리한 사실에 대하여도 가감없이 알려주어 합리적인 선택과 결과를 도출해냅니다.',
  },
];

export const contactInfo = {
  officePhone: '042-721-0105',
  mobilePhone: '010-2833-1395',
  naverBooking: 'https://m.booking.naver.com/booking/6/bizes/1236562?theme=place&entry=pll&lang=ko',
  blog: 'https://www.youtube.com/@LAW_3minute',
  address: '대전 서구 둔산중로78번길 26 민석타워 606호',
};

export const navLinks = [
  { label: '홈', href: '#home' },
  { label: '변호사 소개', href: '#career' },
  { label: '언론보도', href: '#press' },
  { label: '수행사건', href: '#practice' },
  { label: '상담문의', href: '#contact' },
];

export const pressList = [
  {
    title: '사내불륜 정신적 피해로 전문가와 위자료 물을 수 있어',
    source: '글로벌에픽',
    date: '2026.01.02',
    url: 'https://www.globalepic.co.kr/view.php?ud=2026010216063566496cf2d78c68_29',
  },
  {
    title: '사실혼관계 재산분할, 입증이 핵심',
    source: '글로벌에픽',
    date: '2026.03.31',
    url: 'https://www.globalepic.co.kr/view.php?ud=2026033110570546536cf2d78c68_29',
  },
  {
    title: '조정이혼과 재판이혼, 장단점 비교 후 선택해야 [신가영 변호사 칼럼]',
    source: '미디어파인',
    date: '2026.06.10',
    url: 'https://www.mediafine.co.kr/news/articleView.html?idxno=80623',
  },
  {
    title: '재산분할 소송, 이혼 변호사와 준비없이 시작한다면 불리할 수 있어',
    source: '라이브뉴스',
    date: '2025.12.05',
    url: 'https://www.livesnews.com/news/article.html?no=57460',
  },
  {
    title: '상간자 위자료소송, 합법적 증거수집의 중요성',
    source: '빅데이터뉴스',
    date: '2026.03.05',
    url: 'https://www.thebigdata.co.kr/view.php?ud=2026030510085369246cf2d78c68_23',
  },
  {
    title: '이혼 후 경제적 기반이 되는 재산분할, 전략적 접근 필요해',
    source: '경상일보',
    date: '2025.08.04',
    url: 'https://www.ksilbo.co.kr/news/articleView.html?idxno=1033559',
  },
];